export class DadosPagamento {
    banco: string;
    operacao: number;
    agencia: number;
    conta: string;
    pix: string;
    nomeCompleto: string;
    cpfTitular: string;
}
